import {useCookies} from 'react-cookie'

const SliderBar = () => {
const [cookies, setCookie] = useCookies(['UserId','AuthToken','distance', 'max_price'])

  const handleDistanceChange = (e) => {
    setCookie('distance',e.target.value);
  };
  const handleMaxPriceChange = (e) => {
    setCookie('max_price', e.target.value);
  };
  return (
    <div className="slider-container">
      <input
        type="range"
        min="0.1"
        max="25"
        step="0.1"
        value={cookies.distance}
        onChange={handleDistanceChange}
        className="slider"
      />
      <div className="value-display">Maximal {cookies.distance} km entfernt</div>
      <input
        type="range"
        min="0.05"
        max="200"
        step="0.05"
        value={cookies.max_price}
        onChange={handleMaxPriceChange}
        className="slider"
      />
      <div className="value-display">Preislimit (CHF): {cookies.max_price}</div>
    </div>
    
  );
};

export default SliderBar;